import { useStore } from 'stores';
import { useTranslation } from 'react-i18next';
import Select from 'components/Select';

export default function SymbolSelect() {
  const { t } = useTranslation();
  const stockList = useStore((state) => state.BQMarketName);
  const currentStock = useStore((state) => state.currentStock);
  const setCurrentStock = useStore((state) => state.setCurrentStock);

  return (
    <Select
      title={t('AllStock.symbol')}
      options={stockList}
      type="symbol"
      value={currentStock?.marketId}
      onSelectChange={(e) => {
        setCurrentStock(stockList.find(({ marketId }) => marketId === e.target.value));
      }}
    />
  );
}
